import "./HomePartStyles.css"

const HomePart = () =>{
    return(
        <div className="home-container">
            <img src="https://static.igem.wiki/teams/4696/wiki/homepage-1-test.png" className="section1-pic" alt="homepage1" draggable='false'></img>
            <img src="https://static.igem.wiki/teams/4696/wiki/homepage-section2.png" className="section1-pic" alt="homepage1" draggable='false'></img>
            <img src="https://static.igem.wiki/teams/4696/wiki/homepage-section3.png" className="section1-pic" alt="homepage1" draggable='false'></img>
        </div>
    )
}

export default HomePart